import { App } from "antd";
import { useEffect, useState } from "react";
import { useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { AvailabilityDayProps, ValueType } from "../../types/date";
import useCurrentUser from "../../hooks/useCurrentUser";
import { DELETE_AVAILABILITIES } from "./availabilities.gql";

const useAvailabilityDay = (props: AvailabilityDayProps) => {
  const { t } = useTranslation();
  const { item, values } = props;
  const [enabled, setEnabled] = useState(false);
  const { message } = App.useApp();
  const { refetchUser, availabilities } = useCurrentUser();

  const [remove, {
    loading
  }] = useMutation(
    DELETE_AVAILABILITIES,
    {
      fetchPolicy: "no-cache",
      onError({ graphQLErrors }) {
        message.error(graphQLErrors[0].message);
      },
      onCompleted() {
        refetchUser();
        message.success(t("apollo.success.deleteAvailabilities"));
      }
    },
  );

  useEffect(() => {
    setEnabled(!!values[item.name]);
  }, [values, item]);

  const handleOnSwitch = (checked: boolean, day: ValueType) => {
    if (day?.list) {
      if (availabilities.length === 1) {
        message.error(t("availabilityPage.error.atLeastOneAvailabilityRequired"));
        return;
      }

      remove({
        variables: {
          ids: day.list.map((time: any) => time.id)
        }
      }).then((data) => {
        if ("data" in data) setEnabled(checked);
      });
    } else {
      setEnabled(checked);
    }
  };

  return {
    enabled,
    handleOnSwitch,
    loading
  };
};

export default useAvailabilityDay;
